import type { UserProfile } from '../models/login.model';
import { CrudService } from './crud.service';

export class OauthService {
  private readonly crudService = new CrudService('login/oauth');

  public async callback(code: string): Promise<UserProfile> {
    const params = new URLSearchParams();
    params.set('code', code);

    try {
      const { model } = await this.crudService.do('GET', `callback?${params}`, undefined, undefined, 'throw');

      return model;
    } catch (e: any) {
      throw new Error(e.response?.data?.messageCode || 'backend.oauth_login.attempt_failed_unknown');
    }
  }
}
